// extracted by mini-css-extract-plugin
export default {"titleActions":"AliasPreferences_titleActions__V4OD1","tableContainer":"AliasPreferences_tableContainer__7vXyZ"};